import Back from "../components/Back";
import CreateEditEvent from "../components/CreateEditEvent";
import Menu from "../components/Menu";

export default function CreateEvent() {
  return (
    <div>
      <div className="container" />
      <Back title="Buat Event" />
      <div className="content">
        <CreateEditEvent />
      </div>
      <Menu />
    </div>
  );
}
